// 域名
// var domainname = "http://idc-tj-cmcc.haixingcloud.com:9000"
// var domainname = "http://idc-tj-cmcc.haixingcloud.com:8000"

var domainname = 'https://www.haixingcloud.com:8000'
// var domainname = 'http://localhost:8000'

// 登录
var Signin = '/api/login'
// 验证码登录
var dxSignin = '/api/login?type=sms'
// 注册
var register = '/api/users'
// 绑定微信
var bindwechat = '/api/users/bind_wechat'
// 手机验证码
// 前边
var Verification = '/api/users/phone_auth'
// 后边
// var code = "/phone_auth"

// 注册判断手机号是否存在
var phoneq = '/api/users/' // 前
var phoneh = '/phone_exist' // 后
// 注册判断身份证号是否存在
var idcardq = '/api/users/' // 前
var idcardh = '/idcard_exist' // 后
// 注册判断邮箱是否存在
var emailq = '/api/users/' // 前
var emailh = '/email_exist' // 后

// 注册判断邀请码是否存在
var Invitationq = '/api/users/' // 前
var Invitationh = '/invitation_code_exist' // 后
// 实名认证
var realname = '/api/users/activate'
// 个人中心  我的
var userinfo = '/api/users/login/userinfo'
// 充值接口
var pay = '/api/pay?'
var payone = '/api/pay?totalfee=' // 金额
var paytwo = '&totalpoints=' // 点数

// 充值记录查询
var orderlist = '/api/users/login/orderlist'
// 消费记录查询
var chargelist = '/api/users/login/chargelist'
// 消费状态查询
var checkpaystatus = '/api/pay/checkpaystatus?outtradeno='
// 付费文章      传文章id
var fufeiwenzhangq = '/api/users/' // 前
var fuweiwenzhangh = '/article_id_exist' // 后
// 查询文章   类型
var chawzq = '/api/article/' // 前
var chawzh = '/type' // 后
// 查询文章   id
var chawzidq = '/api/article/' // 前
var chawzidh = '/id' // 后
// 查询版本更新
var banben = '/api/clientversion/groupby'
// 修改密码
var reset = '/api/users/password_reset'
var gift_card = '/api/users/gift_card'
var gift_points = '/api/users/gift_points'
// 查看产品
var invest = '/api/product/product_list?client_type=0'
// 查看周卡产品
var ckzhouk = '/api/timecard'
// 查看用户所购买的周卡
var payzk = '/api/users/username/time_card'
// 激活 周卡
var jihuozkq = '/api/users/'
var jihuozkh = '/activate_time_card'
// 提点
var invite_bonus = '/api/users/invite_bonus'
// 客户端下载链接获取
var Downloadlink = '/api/clientversion'
// 提现
var withdrawal = '/api/withdrawal'

export default {
  // 域名
  domainname,
  // 登录
  Signin,
  // 短信登录
  dxSignin,
  // 注册
  register,
  bindwechat,
  // 手机验证码
  Verification, // 前
  // code,//后
  // 注册判断手机号是否存在
  phoneq, // 前
  phoneh, // 后
  // 注册判断身份证是否存在
  idcardq, // 前
  idcardh, // 后
  // 注册判断邮箱是否存在
  emailq, // 前
  emailh, // 后
  // 注册判断邀请码是否存在
  Invitationq, // 前
  Invitationh, // 后
  // 实名认证
  realname,
  // 个人中心 我的余额
  userinfo,
  // 充值
  pay,
  // payone,//金额
  // paytwo,//点数
  // 查询充值记录
  orderlist,
  // 消费查询
  chargelist,
  // 消费状态查询
  checkpaystatus,
  // 付费文章
  fufeiwenzhangq, // 前
  fuweiwenzhangh, // 后
  // 修改密码
  reset,
  // 转账
  gift_points,
  // 查看产品
  invest,
  // 类型  查询文章
  chawzq, // 前
  chawzh, // 后
  // id  查询文章
  chawzidq, // 前
  chawzidh, // 后
  // 查询版本号
  banben,
  // 查看周卡
  ckzhouk,
  // 查看用户购买的周卡
  payzk,
  // 激活周卡
  jihuozkq,
  jihuozkh,
  gift_card,
  invite_bonus,
  Downloadlink,
  withdrawal
}



// WEBPACK FOOTER //
// ./src/common/api.js